import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';

/**
 * Custom `ErrorStateMatcher` that marks a control as in error as soon as it becomes invalid
 * and the user has interacted with it.
 * Error when invalid control is dirty, touched, or submitted.
 * Use for showing validation messages immediately while typing.
 */
export class ImmediateErrorStateMatcher implements ErrorStateMatcher {
	public isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
		if (!control) return false;
		const isSubmitted = form && form.submitted;
		return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}
